import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  status;

  constructor(public router: Router) {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/header/header.component.ts